import React from "react"

import { FaExternalLinkAlt } from "../../../../AppReactIcons"
import ExternalLink from "./ExternalLink"
import Heading from "./Heading"
import { iLink } from "./types"

interface iRelatedVideos {
  links: iLink[]
}

const RelatedVideos: React.FC<iRelatedVideos> = ({ links }) => {
  if (!links) return null
  if (!links.length) return null
  return (
    <div>
      <Heading text="Related Videos" />
      <div className="mt-2">
        {links.map((item, index) => {
          return (
            <ExternalLink
              Icon={<FaExternalLinkAlt className={"inline"} />}
              link={item}
              key={index}
            />
          )
        })}
      </div>
    </div>
  )
}

export default RelatedVideos
